import React, { useState, useEffect } from 'react';
import { Modal } from "react-bootstrap";
import { LanguageProvider } from '../../../core/language-provider';
import FormEntityInstanceCompiler from '../../../components/Entity/FormEntityInstanceCompiler';
import { settings } from '../../../config/settings';


export default function ModalEntityCompiler({ entity = null, confirmCallback, initData={}, excludedFields=[], status, close }) {

    useEffect(() => {
        if(entity !== null) {
            
        }
    }, [entity]);


    function closeModal() {
        close()
    }

    function save(data) {
        confirmCallback(data)
    }


    if(status !== false && entity !== null) { 
        return (
            <>
                <Modal show={status} onHide={closeModal} size={settings.modalDefaultSize && settings.modalDefaultSize.entityCompiler ? settings.modalDefaultSize.entityCompiler : "xl"} scrollable={true} backdrop="static">
                    <Modal.Header closeButton>
                        <Modal.Title>{LanguageProvider.get('entity.'+entity)}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <FormEntityInstanceCompiler entity={entity} confirmCallback={save} initData={initData} excludedFields={excludedFields} />
                    </Modal.Body>
                </Modal>
            </>
        );
    }
};